const key = "add-requestable-form-message";

const applicable = (resp) => {
	return resp?.config?.method === "GET"
		&& resp?.config?.url.match(/api\/forms\?requestable=true$/);
};

const message = `# Request Access

Welcome to the **request flow** for this form.

Please review the following before you continue:

- Confirm your profile details are current.
- Gather any required supporting documents.
- Read the [requesting guide](https://example.com/requesting-guide).

## What Happens Next

1. Submit your request.
2. Watch for an email confirmation.
3. Return later to check the request status.

> Support tip: include the exact entity name in your request.

Need help? Contact **VESL Support** or visit the [help center](https://example.com/help-center).

Use the code \`REQUEST-DEMO\` when contacting support.`;

const modify = (resp) => {
	if(!resp?.data?.Data)
		return;

	resp.data.Data
		.filter(form => form.IsRequestable)
		.forEach(form => {
			form.Onboarding = {
				...(form.Onboarding ?? {}),
				Requests: {
					...(form.Onboarding?.Requests ?? {}),
					Mode: { Code: "MESSAGE" },
					Message: message
				}
			};
		});

	return resp;
};

export const addRequestableFormMessage = [key, applicable, modify];